import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getFoodCategories(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/category/getall`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addCategory(ctx, queryParams){
            const data = queryParams

            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/category/add`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },

        updateCategory(ctx, queryParams){
            const id = queryParams.id
            const data = queryParams
            
            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/category/update/${id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteCategory(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete('/food/v1/category/delete/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        getFood(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/menu/getall`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addFood(ctx, queryParams){
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/menu/add`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },

        updateFood(ctx, queryParams){
            var data = JSON.stringify(queryParams);
            const id = queryParams.id

            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/menu/update/${id}`, data)
                    .then(response => {resolve(response)})
                    .catch(error => reject(error))
            })
        },

        deleteFood(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete(`/food/v1/menu/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        getFoodAllergies(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/allergy/getAllergies`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addFoodAllergy(ctx, queryParams){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/allergy/addAllergy`, queryParams.formData, {
                        headers:{
                            'Content-Type': 'multipart/form-data',
                            'dataType':'json'
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateFoodAllergy(ctx, queryParams){
            const id = queryParams.data.id

            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/allergy/update/${id}`, queryParams.formData, {
                        headers:{
                            'Content-Type': 'multipart/form-data',
                            'dataType':'json'
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteFoodAllergy(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/food/v1/allergy/delete/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        getFolders(){
            return new Promise((resolve, reject) => {
              axios
                .get('/files/v1/folder/getFolders')
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        updateOrdering(ctx, queryParams) {
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/food/v1/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        getSubCategoryData(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/sub-category/lists`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addSubCategoryData(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/sub-category/add`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateSubCategoryData(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/food/v1/sub-category/update`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteSubCategoryData(ctx, queryParams){
            const data = JSON.stringify(queryParams);

            return new Promise((resolve, reject) => {
                axios
                    .delete(`/food/v1/sub-category/delete/${data}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }
    }
}